<div class="login_p_section" [ngClass]="{'openlookzupbusinessbg': registrationDone && currentScreenWidth < 1200}">
  <div class="container ">
    <div class="">
    <div class="row align-items-center">
      <div class="col-md-6 d-none d-md-block">
        <div class="login-info">
          <div class="new_logo">
            <img src="../../../../assets/images/lookzup-business-logo.png" />
          </div>
          <p class="mt-2 dedifclass">
            Dedicated platform for the Fitness, Beauty and Grooming industry. Manage business, bookings, billings, payments, employees, customers, members and promotions.
             A must-have productivity tool for business owners and individual professionals.
          </p>
          <div class="login_ttg">
            <div class="list_flex">
             <mat-icon>task_alt</mat-icon> <span>Multi currency</span>
            </div>
            <div class="list_flex">
              <mat-icon>task_alt</mat-icon> <span>Import old data</span>
            </div>
            <div class="list_flex">
              <mat-icon>task_alt</mat-icon> <span>Express support</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div id="first-form">
          <mat-card class="card newrt p-4">
            <h4 class="mb-2 d-none d-md-block">Welcome to LookzUp</h4> <!-- Visible only on desktop -->
            <div class="login_img_section d-block d-md-none">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> <!-- Visible only on mobile -->
            
            <p class="join_heading">
              Join the platform and manage your Salon, Parlor, Spa, Makeup Studio, Gym, Fitness, Yoga and Wellness Center like never before.
            </p>
            <!-- login -->
            <form>
              <!-- <mat-form-field appearance="outline" class="full-width">
          <mat-label>Country</mat-label>
          <mat-select [(value)]="selectedCountry">
            <mat-option *ngFor="let country of countryList" [value]="country.code">
              <ng-container *ngIf="country.flagClass;">
                <img [src]="country.imageUrl" alt="{{ country.name }}" class="country-flag" /> 
                <span class="flag-icon" [ngClass]="country.flagClass"></span> {{ country.name }} (+{{ country.code }})
              </ng-container>
           
            </mat-option>
          </mat-select>
        </mat-form-field> -->

         
              <mat-form-field class="w-100" appearance="outline">
                <mat-select
                  placeholderLabel="Search"
                  name="primarySelectedSpecialityCtrl"
                  [(value)]="selectedCountry"
                  (selectionChange)="onCountrySelected($event)"
                  #primarySpecialitiesSelector
                >
                  <mat-option>
                    <ngx-mat-select-search
                      noEntriesFoundLabel="no results found"
                      name="countrysearch"
                      placeholderLabel="Enter country name"
                      [formControl]="searchString"
                      (keyup)="onKey()"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let country of countryList"
                    [value]="country"
                  >
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Phone Number</mat-label>
                <input
                  matInput
                  type="tel"
                  name="phone"
                  minLength="3"
                  maxlength="17"
                  [(ngModel)]="phone"
                  placeholder="Enter your phone number"
                  smNumericOnly
                />
              </mat-form-field>

              <div class="verify_btn">
                <button
                  mat-flat-button
                  color="primary"
                  class="full-width"
                  [disabled]="
                    
                    !phone || phone.length < 3 || phone.length > 17"
                  #submitButton
                  (click)="onSendOTP()"
                >
                  Verify mobile
                </button>
              </div>
            </form>
            <p class="footer-text">
              By verifying mobile and registering with us, you are agreeing and consenting to our
              <a href="https://lookzup.com/terms" target="_blank">Terms of Services</a> and
              <a href="https://lookzup.com/privacy" target="_blank" >Privacy policy</a>.
            </p>

            <p class="footer-text">
              Looking for beauty and grooming services for you and your family?
              <a (click)="openCustomerWebsite()" style="text-decoration: underline;color: #222;cursor: pointer;"
                >Login to LookzUp Marketplace.</a>
            </p>

            <!-- login end -->
          </mat-card>
        </div>

        <!-- otp start -->
        <div *ngIf="otpReceived && !showProfileForm && !toshowblockedmessage && (!registrationDone || currentScreenWidth >= 1200)">
          <mat-card class="card newrt p-4">
            <!-- <h4 class="mb-2">Welcome to LookzUp</h4> -->
            <div class="login_img_section d-block d-md-none">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> 
            <p class="join_heading">
              Join the platform and manage your Salon, Parlor, Spa, Makeup Studio, Gym, Fitness, Yoga and Wellness Center like never before.
            </p>
            <!-- login -->

            <form>
              <div class="tht_sectionm">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Phone Number</mat-label>
                  <input matInput [value]="userPhoneNumber" disabled type="tel" />
                  <mat-icon matSuffix class="material-icons-outlined" (click)="onbacklogin()" style="cursor: pointer;">edit</mat-icon>
                  <!-- <button mat-icon-button matSuffix (click)="onbacklogin()">
                  </button> -->
                </mat-form-field>
              </div>
              <div class="otp-container">
                <input
                  type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 0)"
                  name="first"
                  [(ngModel)]="otp[0]"
                  id="box0"
                  (paste)="handlePaste($event)"
                />
                <input
                  type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 1)"
                  name="second"
                  [(ngModel)]="otp[1]"
                  id="box1"
                />
                <input
                  type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 2)"
                  name="third"
                  [(ngModel)]="otp[2]"
                  id="box2"
                />
                <input
                type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 3)"
                  name="fourth"
                  [(ngModel)]="otp[3]"
                  id="box3"
                />
                <input
                type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 4)"
                  name="fifth"
                  [(ngModel)]="otp[4]"
                  id="box4"
                />
                <input
                type="tel"
                  maxlength="1"
                  class="otp-input"
                  (input)="onInput($event, 5)"
                  name="sixth"
                  [(ngModel)]="otp[5]"
                  id="box5"
                />
              </div>
              <div class="small_tht">
                <p>
                  Enter the verification code you received in your mobile from LookzUp platform.
                </p>
              </div>

              <div class="verify_btn">
                <button mat-flat-button color="primary" class="full-width" [disabled]="checkOtpDisability()" (click)="onSignIn()">
                  Confirm
                </button>
              </div>
              <div class="resend_code_heading">
                <p>
                  Haven't received any verification code yet? <a href="javascript:void(0)" (click)="onSendOTP()" [style.pointerEvents]="resendDisabled ? 'none' : 'auto'"
    [style.color]="resendDisabled ? 'gray' : '#222'" class="resend_tter">Re-send code</a>.
                </p>
              </div>
            </form>
          </mat-card>
        </div>

        <div *ngIf="showProfileForm && !toshowblockedmessage && (!registrationDone || currentScreenWidth >= 1200)">
          <mat-card class="card newrt p-4">
            <div class="login_img_section d-block d-md-none">
              <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
            </div> 
            <p class="join_heading">
              Join the platform and manage your Gym, Salon, Yoga, Wellness Center, Parlor, Spa, Makeup and Fitness Studio like never before. Share a little about you.
            </p>
          <form [formGroup]="signInForm">
            <ng-template matStepLabel>Profile</ng-template>
            <div class="row g-2 mb-3 justify-content-between phone-field">
              
              <mat-form-field appearance="outline" class="col-12">
                <mat-label>Your name</mat-label>
                <input
                  matInput
                  
                  formControlName="name"
                  required
                />
                
              </mat-form-field>
              <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()">
                  <mat-label>Date of birth</mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="dob" readonly>
                  <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field>
                <!-- <div class="radio_group">
                  <label>Gender: </label>
                  <mat-radio-group formControlName="gender">
                    <mat-radio-button value="Male">Male</mat-radio-button>
                    <mat-radio-button value="Female">Female</mat-radio-button>
                    <mat-radio-button value="Others">Others</mat-radio-button>
                  </mat-radio-group>
                </div> -->
                <mat-form-field appearance="outline">
                  <mat-label>Address</mat-label>
                  <input
                  formControlName="address"
                    matInput
                    (input)="updateSearchResults()"
                    [matAutocomplete]="auto"
                  />
                  <!-- <mat-icon matSuffix class="material-icons-outlined"
                    >person_pin_circle</mat-icon
                  > -->
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      *ngFor="let item of autocompleteItems"
                      (click)="selectSearchResult(item)"
                    >
                      {{ item.description }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                 <mat-hint
                  style="
                    color: red;
                    font-size: 13px;
                    margin-top: 0px;
                    position: relative;
                    top: -10px;
                  "
                  align="end"
                  *ngIf="isAddressNotSelectedFromList"
                >
                  Please pick an address from the dropdown.
                </mat-hint>
            </div>
            
            <button
              mat-flat-button
             style="    width: 100%;
             background: #FFC107;
             border-radius: 20px;
             color: white;
             height: 45px;"
              class="w-100"
              [disabled]="signInForm.invalid"
              (click)="onRegister()"
            >
              Save and Go
            </button>
            <div class="resend_code_heading" style="margin-top: 20px;">
              <p>
                Want to exit from here? <a href="javascript:void(0)" (click)="logout()">Logout.</a>
              </p>
            </div>
          </form>
        </mat-card>
        </div>
        <div *ngIf="toshowblockedmessage && (!registrationDone || currentScreenWidth >= 1200)">
          <mat-card class="card newrt p-4">
          <div>
            <h1 class="head-text" >Your account is blocked.</h1>
            <p class="head-text1" >LookzUp Admin blocked your account due to the following reason:</p>
            <p class="head-text1" style="font-weight: 600;">{{blockedUserData.block_reason}}</p>
          </div>
          <div style="margin: 20px 0px 0px;border-top: 1px solid lightgrey;padding-top: 15px;">
            <p class="">Provide grievance or request unblock.</p>
            <mat-form-field class=" w-100"  style="margin-top: 0px;" appearance="outline" >
              <textarea matInput #input placeholder="Enter your grievance" autocomplete="off" [(ngModel)]="blockedUserGrievance"></textarea>
            </mat-form-field>
          </div>
          <div style="    text-align: right;">
            <button
            style="margin-bottom: 20px;"
            mat-flat-button
            color="accent"
            [disabled]="!blockedUserGrievance"    
            (click)="sendUnblockRequest()"
          >
            Send
          </button>
          </div>
        </mat-card>
        </div>

       <!-- mobile start-->
  <div class="login_cardg_wert" *ngIf="registrationDone && currentScreenWidth < 1200">
    <div class="header_lox_new">
      <img src="../../../../assets/images/lookzup-business-logo.png" />
    </div>
    <mat-card style="margin-bottom: 15px;">
      <div class="login_cardf_secr">
        <h3>LookzUp works better as app.</h3>
        <p style="color: #333;">Download the LookzUp Business app from Google Play Store or Apple App Store. Install in your phone, login, and start managing your Salon, Parlour, Spa, Gym, Yoga or Fitness center.</p>
      
          <div  class="playstore-img">
            <div class="play_store_social d-flex">
              <div  style="margin-right: 15px; margin-top: 12px;">
                <a href="https://play.google.com/store/apps/details?id=com.lookzup.app.android.business" target="_blank">
                <img src="./assets/images/playstore.png" class="linkImages">
              </a>
              </div>

                <div style="margin-top: 12px;">
                  <a (click)="opentoast()">
                  <img  src="./assets/images/applestore.png" class="linkImages">
                  </a>
                </div>
                
              </div>
          </div>
        </div>
    </mat-card>
    <mat-card>
      <div class="login_headingty">
        <h3>Continue as web app in browser.</h3>
        <p style="color: #333;">With the web application in your mobile browser, few non-essential functionality may not work. Though you can manage your business, booking, billing, member, employee, payment, expense, customer and promotions seamlessly.</p>
      <div class="featutr_btn">
        <button mat-stroked-button (click)="openApp()">Open LookzUp Business <mat-icon> navigate_next </mat-icon></button>
      </div>
      </div>
    </mat-card>
  </div>
  <!-- mobile end -->

      </div>
    </div>
  </div>
  </div>


</div>
